import { Pipe, PipeTransform } from '@angular/core';
import { ICExperiment, ICExperimentStatus } from '../services/labpartner.service.model';

@Pipe({
  name: 'icstatusIs',
  standalone: false,
})
export class ICExperimentStatusIsPipe implements PipeTransform {
  constructor() {}

  transform(
    experiment: ICExperiment | null,
    statuses: (keyof typeof ICExperimentStatus)[],
  ): boolean {
    if (!experiment) {
      return false;
    }

    for (const status of statuses) {
      if (ICExperimentStatus[experiment.status] == status) {
        return true;
      }
    }
    return false;
  }
}
